<template>
  <div class="w-full flex flex-col">
    <div class="m-2 p-2 bg-white rounded shadow flex flex-col" style="height: 100%; max-height: 100%;" v-if="loaded">
      <div class="flex flex-row items-center">
        <p class="p-2 text-lg font-medium text-primary flex-grow">Training Matrix</p>
        <IconMenu :actions="menuActions" :contextData="{ store, form, db }" />
      </div>
      <DataTable :tableSettings="{ ...tableConfig, columnState: tableConfig.columnDefs }" :items="people"
        :paginationPageSize="50" ref="table" />
    </div>
  </div>
  <DynamicForm ref="form" @submitted="getData" />
</template>
<script setup>
import { ref, computed, onMounted } from "vue";
import { useStore } from "vuex";
import { DataTable, IconMenu } from "@comp";
import DynamicForm from "../../../components/DynamicForm/DynamicForm.vue";
import _trainingMatrixTableConfig from "./trainingMatrixTableConfig.js";
import { completeTraining } from "./actions.js";
import { db } from "../../../db.js";

const store = useStore();
const form = ref(null);
const table = ref(null);
const loaded = ref(false);

const materials = computed(() =>
  Object.entries(store.state["Home/TrainingMaterial"] || {}).filter(
    ([, m]) => m.IncludeInMatrix
  )
);

function getTrainingStatus(material, userId) {
  

  const dateStr = material.Users?.[userId]?.Date;
  if (!dateStr) return "incomplete";

  const completedDate = new Date(dateStr);
  const validLength = material.ValidLength;

  if (!validLength) return "indate";

  const expiryDate = new Date(completedDate);
  expiryDate.setMonth(expiryDate.getMonth() + parseInt(validLength, 10));

  
  return new Date() < expiryDate ? "indate" : "overdue";
}

const people = computed(() => {
  const users = Object.values(store.state.users || {}).filter((u) => u.showTraining && u.main);
  return users.map((user) => {
    const materialStatuses = {};
    for (const [materialId, material] of materials.value) {
      materialStatuses[`Materials_${materialId}`] = getTrainingStatus(material, user.key);
    }
    return {
      ...user,
      ...materialStatuses,
    };
  });
});

const tableConfig = computed(() => _trainingMatrixTableConfig(store));

const menuActions = computed(() => [
  {
    label: "Complete Training",
    action: completeTraining,
    lock: () => !store.state.user.Security.Training
  },
]);

const getData = async () => {
  await Promise.all([
    db.watch("Home/TrainingMaterial", store),
    db.watch("users", store),
  ]);
};

onMounted(async () => {
  await getData();
  loaded.value = true;
});
</script>
